import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import { Field } from 'formik'
import dotty from 'dotty'

import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import FormHelperText from '@material-ui/core/FormHelperText'
import MarkdownHelperText from './MarkdownHelperText'

import utils from './utils'

import Errors from './Errors'

const useStyles = makeStyles(theme => ({
  errorContainer: {
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  },
  header: {
    marginTop: `0px`,
    marginBottom: `0px`,
    fontWeight: 'bold',
  },
  divider: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  fullHeight: {
    height: '100%',
  },
  mainError: {
    padding: theme.spacing(1),
  },
}))

const FormWrapperItem = ({
  item,
  values,
  errors,
  readOnly,
  touched,
  handlers,  
  onSubmit,
}) => {

  const fieldError = dotty.get(errors, item.id)
  const fieldTouched = dotty.get(touched, item.id)

  const useItem = Object.assign({}, item, {
    helperText: (
      <MarkdownHelperText
        text={ item.helperText }
      />
    )
  })

  return (
    <Field
      name={ item.id }
      component={ utils.getComponent(item.component) }
      item={ useItem }
      values={ values }
      disabled={ readOnly }
      error={ fieldError }
      touched={ fieldTouched }
      handlers={ handlers }
      onSubmit={ onSubmit }
    />
  )
}

const FormWrapperRow = ({
  rowKey,
  row,
  values,
  readOnly,
  errors,
  touched,  
  handlers,
  onSubmit,
}) => {
  const classes = useStyles()
  if(typeof(row) === 'string') {
    return (
      <Grid item xs={ 12 } key={ rowKey }>
        {
          row == '-' ? (
            <Divider className={ classes.divider } />
          ) : (
            <Typography
              variant='subtitle1'
              className={ classes.header }
            >
              { row }
            </Typography>
          )
        }
        
      </Grid>
    )
  }
  else if (row.constructor === Array) {
    const colSize = Math.floor(12 / row.length)
    return row
      .filter(item => {
        if(!handlers.hidden) return true
        return handlers.hidden({
          name: item.id,
          values,
        }) ? false : true
      })
      .map((item, i) => (
        <Grid item xs={ 12 } sm={ colSize } key={ rowKey + '-' + i }>
          <FormWrapperItem
            item={ item }
            values={ values }
            errors={ errors }
            readOnly={ readOnly }
            touched={ touched }
            handlers={ handlers }
            onSubmit={ onSubmit }
          />
        </Grid>
      ))
  }
  else {
    if(handlers.hidden && handlers.hidden({
      name: row.id,
      values,
    })) {
      return null
    }
    
    return (
      <Grid item xs={12} key={ rowKey }>
        <FormWrapperItem
          item={ row }
          values={ values }
          errors={ errors }
          readOnly={ readOnly }
          touched={ touched }          
          handlers={ handlers }
          onSubmit={ onSubmit }
        />
      </Grid>
    )
  }
}

const FormRender = ({
  schema,
  handlers = {},
  error,
  values,
  errors,
  touched,
  readOnly,
  showErrors,
  fullHeight,
  onSubmit,
}) => {

  const classes = useStyles()
 
  return (
    <React.Fragment>
      <Grid
        container
        spacing={ 2 }
        className={classnames({
          [classes.fullHeight]: fullHeight,
        })}
      >
        {
          schema.map((row, i) => {
            return (
              <FormWrapperRow
                key={ i }
                rowKey={ i }
                row={ row }
                readOnly={ readOnly }
                values={ values }
                errors={ errors }
                touched={ touched }
                handlers={ handlers }
                onSubmit={ onSubmit }
              />
            )
          })
        }
        {
          error && (
            <div className={ classes.mainError }>
              <FormHelperText
                error={ true }
              >
                { error }
              </FormHelperText>
            </div>
          )
        }
      </Grid>
      {
        showErrors && (
          <Errors
            errors={ errors }
          />
        )
      }
    </React.Fragment>
  )
}

export default FormRender